import { useCallback, useRef, type ReactNode } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
	formControlHeight,
	formPrimary,
	getSelectChevron,
	selectChevronCapClassName,
} from "@config/theme/formControls";

interface SelectFieldWrapperProps {
	children: ReactNode;
	className?: string;
	controlHeight?: number;
}

export const SelectFieldWrapper = ({
	children,
	className = "",
	controlHeight = formControlHeight,
}: SelectFieldWrapperProps) => {
	const wrapperRef = useRef<HTMLDivElement>(null);
	const chevron = getSelectChevron(controlHeight);
	const iconSize = controlHeight <= 34 ? 14 : controlHeight <= 44 ? 14 : 16;

	const openSelect = useCallback(() => {
		const root = wrapperRef.current;
		if (!root) return;

		const combo = root.querySelector('[role="combobox"]') as HTMLElement | null;
		const selectArea = root.querySelector(".MuiSelect-select") as HTMLElement | null;
		const target = combo ?? selectArea;
		if (!target) return;

		target.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true, view: window }));
		target.click();
	}, []);

	return (
		<div ref={wrapperRef} className={`relative w-full [&_.MuiInputBase-root]:!shadow-none ${className}`}>
			{children}
			<button
				type="button"
				className={selectChevronCapClassName}
				style={{
					top: controlHeight / 2,
					transform: "translateY(-50%)",
					width: chevron.width,
					height: chevron.height,
					borderRadius: chevron.borderRadius,
					right: chevron.rightInset,
					backgroundColor: formPrimary,
				}}
				onClick={openSelect}
				onMouseDown={e => e.preventDefault()}
				aria-label="Open dropdown"
				tabIndex={-1}>
				<KeyboardArrowDownIcon sx={{ color: "#fff", fontSize: iconSize, pointerEvents: "none" }} />
			</button>
		</div>
	);
};
